export async function copyToClipboard(text: string): Promise<boolean> {
    /* ① 原生桥接（放最前，最可靠，不受安全上下文 / 用户手势限制） */
    // Android
    if (window.AndroidApp && window.AndroidApp.copyText) {
        try {
            window.AndroidApp.copyText(text);
            return true;
        } catch (error) {
            console.error('Copy to clipboard failed (AndroidApp):', error);
            // 桥接异常时不直接失败，继续尝试后续方式
        }
    }
    // iOS：仅当 App 注册了 copyText handler（新版本）时存在，旧版本无此桥接会自动落到后续方式
    const iosCopyHandler = window.webkit?.messageHandlers?.copyText;
    if (iosCopyHandler?.postMessage) {
        try {
            iosCopyHandler.postMessage({ text });
            return true;
        } catch (error) {
            console.error('Copy to clipboard failed (iOS bridge):', error);
            // 桥接异常时不直接失败，继续尝试后续方式
        }
    }

    /* ② 标准 Clipboard API：仅在安全上下文可用，且要求在用户手势的同步上下文中调用。
       长按复制走的是定时器回调（非手势），iOS 会 reject —— 失败后必须落到 ③，不能直接返回 false。 */
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (error) {
        console.error('Copy to clipboard failed (clipboard API), fallback to execCommand:', error);
        // 不 return，穿透到 ③
      }
    }

    /* ③ execCommand 回退：兼容 iOS WKWebView。
       iOS 上纯 textarea.select() 拿不到选区，必须用 contentEditable + Range + setSelectionRange。 */
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.readOnly = false;
      textarea.contentEditable = 'true';
      // 保持在视口内但不可见：iOS 对完全移出视口的元素复制不稳定
      textarea.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;pointer-events:none;';
      document.body.appendChild(textarea);

      const isIOS = /iP(hone|ad|od)/.test(navigator.userAgent);
      if (isIOS) {
        const range = document.createRange();
        range.selectNodeContents(textarea);
        const selection = window.getSelection();
        selection?.removeAllRanges();
        selection?.addRange(range);
        textarea.setSelectionRange(0, text.length);
      } else {
        textarea.select();
      }

      const ok = document.execCommand('copy');
      document.body.removeChild(textarea);
      return ok;
    } catch (error) {
      console.error('Copy to clipboard failed (execCommand):', error);
      return false;
    }
  };
